import Event from '../../core/Event';

export default class EstimationProductsPrevRequested extends Event {
    public static type = 'EstimationProductsPrevRequested';

    constructor() {
        super(EstimationProductsPrevRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/EstimationProductsPrevRequested.ts